import { ArrowCounterClockwise, CheckCircle, Clock, LinkSimple, Prohibit, WarningCircle, HourglassMedium } from "@phosphor-icons/react";
import { GROW_LINK_STATUS_LABELS } from "./growUi";
import "./GrowLinks.css";

/**
 * GrowLinkStatusChip — square status chip for one Grow payment link.
 * Visual tone mirrors the finance palette: active (created/sent) = pending
 * amber, paid = primary, expired/cancelled = muted, failed = danger.
 *
 * Props: link ({status, sentAt?}), onClick?, size? ("sm" default | "xs"), className?
 */
const TONE = {
  creating: "active",
  created: "active",
  sent: "active",
  paid: "paid",
  expired: "muted",
  cancelled: "muted",
  failed: "danger",
};

const ICON = {
  creating: HourglassMedium,
  created: LinkSimple,
  sent: Clock,
  paid: CheckCircle,
  expired: Prohibit,
  cancelled: Prohibit,
  failed: WarningCircle,
};

export default function GrowLinkStatusChip({ link, onClick, size = "sm", className = "" }) {
  if (!link?.status) return null;
  const status = link.status;
  // Phase 10: a paid link may carry refunds — status stays "paid", the chip tells the truth
  const refunded = status === "paid" && link.refundStatus ? link.refundStatus : null;
  const tone = refunded === "full" ? "muted" : TONE[status] || "muted";
  const Icon = refunded ? ArrowCounterClockwise : ICON[status] || LinkSimple;
  const label = refunded === "full" ? "זוכה דרך Grow" : refunded === "partial" ? "שולם · זוכה חלקית" : status === "paid" ? "שולם דרך Grow" : GROW_LINK_STATUS_LABELS[status] || status;
  const Tag = onClick ? "button" : "span";

  return (
    <Tag
      type={onClick ? "button" : undefined}
      className={`grow-lchip ${tone} ${size} ${onClick ? "clickable" : ""} ${className}`.trim()}
      onClick={onClick ? (e) => { e.stopPropagation(); onClick(e); } : undefined}
      onKeyDown={onClick ? (e) => e.stopPropagation() : undefined}
      title={onClick ? "פרטי דרישת התשלום" : undefined}
    >
      <Icon size={size === "xs" ? 11 : 13} weight="fill" />
      <span>{label}</span>
    </Tag>
  );
}
